import { render } from "./GibergAhton.vue?vue&type=template&id=3518048a&scoped=true"
import script from "./GibergAhton.vue?vue&type=script&lang=js"
export * from "./GibergAhton.vue?vue&type=script&lang=js"

import "./GibergAhton.vue?vue&type=style&index=0&id=3518048a&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3518048a"]])

export default __exports__